import {
  addDeviceSpecsToApm,
  submitPageImpression,
  trackDevicePixelRatio,
  trackDevicePreferences,
  trackDeviceTextSize,
} from "./async/tracking";

/*                             */
(async () => {
  trackDevicePreferences();
  trackDeviceTextSize();
  await trackDevicePixelRatio();
  submitPageImpression();
  addDeviceSpecsToApm();
})();
